<template>
    <section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 order-2 order-md-1">
                        <!-- Welcome Thumb -->
                        <div class="welcome-thumb mx-auto">
                            <img :src="data.image" alt="">
                        </div>
                    </div>
                    <!-- Welcome Intro Start -->
                    <div class="col-12 col-md-6 order-1 order-md-2">
                        <div class="welcome-intro px-0 px-lg-4">
                            <h1 class="text-white mb-2 mb-md-3">{{data.title}}</h1>
                            <h3 v-if="data.subtitle" class="text-white text-capitalize">{{data.subtitle}}</h3>
                            <p class="text-white mt-3 mb-4">{{data.text}}</p>
                            <p v-if="data.bottomText" class="text-white mt-3 mb-4">{{data.bottomText}}</p>
                            <!-- Store Buttons -->
                            <div v-if="data.link" lass="button-group store-buttons d-flex">
                                <a :href="data.link.url" class="btn sApp-btn text-uppercase">{{data.link.text}}</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    props: ['data']
}
</script>
